<template>
  <div class="page" >
 <studentCard style="display:none;" :snCode='data.snCode' :schoolCode='data.schoolCode' :teacher='data.teacher'/>
 <!-- color='pink' background='pink' -->
  <!-- <van-tabs v-model="active" style="margin:10px;border-radius: 10px;"  @change="activeChange" >
    <van-tab title="成绩及记录"></van-tab>
    <van-tab title="综合分析"></van-tab>
    <van-tab title="强弱项分析及建议"></van-tab>
  </van-tabs> -->
<div class="title_box">
  
  <div class="title">{{finalScoreData.yearName}}
      <van-popover v-model="showPopover"  trigger="click" :actions="yearList" @select="onSelectPopover">
                  <template #reference>
                    <div  >
                      <van-icon name="descending" class="onchangeClass"/>
                    <!-- <van-icon name="exchange" class="onchangeClass"/> -->
                    </div>
                  </template>
        </van-popover>
    体测报告</div>
  <div class="cardRoll_box">
     <div class="cardRoll_badgetopbox"> 
          <img v-show="finalScoreData.level=='优秀'" src="../../assets/parentImg/优秀.png" width="100%"  alt="">
          <img v-show="finalScoreData.level=='良好'" src="../../assets/parentImg/良好.png" width="100%"  alt="">
          <img v-show="finalScoreData.level=='及格'" src="../../assets/parentImg/及格.png" width="100%"  alt="">
          <img v-show="finalScoreData.level=='不及格'" src="../../assets/parentImg/不及格.png" width="100%"  alt="">
        </div>
    <div class="cardRoll_topbox"> 
        <div class="year_score" >
        <span style="font-size: 9.5vw;">{{finalScoreData.finalWeightScore}}</span>
        <span style="">分</span>
        <span class="year_status" style="color:#dddddd;margin-left:4px">
          <!-- <van-icon name="question-o" /> -->
        </span>
      </div>

        <div style="font-size: 14px;color: #333;">{{ finalScoreData.studentName }}</div>
       

    </div>
    <div class="cardRoll_bottombox"> 
      <div class="line"></div>

          <div class="card">
            <div class="cardRoll_bottombox_top">
               <div class="cardRoll_bottombox_topleft">{{ BmiData.height||'--' }} <span style="font-size: 16px;">cm</span> </div>
                <div class="cardRoll_bottombox_topright">{{ BmiData.weight||'--' }} <span style="font-size: 16px;">kg</span></div>
            </div>
            <div class="cardRoll_bottombox_bottom"> 
              <div  class="cardRoll_bottombox_bottomtop">
                <div class="cardRoll_bottombox_bottomtopleft">当前BMI</div>
                <div class="cardRoll_bottombox_bottomtopright">
                  {{BmiData.value||'--' }}
                  <div class="cardRoll_bottombox_bottomtopright_text">{{ BmiData.level||'--'  }}</div>
                </div>
              </div>

    <div class="test-item" >
   
      
      <!-- 主进度条 -->
      <div class="progress-container" >
        <div class="main-progress" >
          <div class="current-marker" :style="markerPosition(BmiData)"></div>
        </div>
      </div>


      <!-- 对比刻度条 -->
      <div class="reference-bar">
        <div class="segment"
             v-for="(seg, index) in getSegments(BmiData)" 
             :key="index"
             >
          <div class="marker" :style="segmentStyle(seg, BmiData)">
          </div>
          <span class="label">{{ seg.label }}</span>
        </div>
      </div>


      


    </div>


            </div>
          </div>
    </div>
  </div>
</div>


<van-skeleton title  :row="10" :loading="loading" style="background-color: #fff;border-radius: 15px;margin: 15px 0;padding: 4vw;">
  <div class="projectBox"  v-show="finalScoreData.finalWeightScore&&finalScoreData.finalWeightScore!==''">
    <div class="project_titleBox">体测成绩 <span style="font-size: 12px;">(最佳)</span> </div>
    <div v-for="(item,i) in projectScoreList" :key="i" class="project_li" @click="toProjectLogBoard(item,i)">
      <div class="project_title">{{item.projectName||''}}</div>
      <div v-if="item.score!=='未测试'">
      <div class="project_score">
          <!-- <div class="project_score_li" v-if="item.projectCode=='HeightWeight'">
          <div class="project_score_li_top">{{item.heightScore}}</div>
          <div class="project_score_li_bottom">身高</div>
        </div>
        <div class="project_score_li" v-if="item.projectCode=='HeightWeight'">
          <div class="project_score_li_top">{{item.score}}</div>
          <div class="project_score_li_bottom">体重</div>
        </div> -->
        <div class="project_score_li" v-if="item.projectCode=='HeightWeight'">
          <div class="project_score_li_top">{{item.score ||'--' }}</div>
          <div class="project_score_li_bottom">BMI</div>
        </div>


        <div class="project_score_li"  v-if="item.projectCode!=='HeightWeight'">
          <div class="project_score_li_top">{{item.fraction||'--' }}</div>
          <div class="project_score_li_bottom">得分</div>
        </div>


        <div class="project_score_li">
          <div class="project_score_li_top">{{item.score}}</div>
          <div  class="project_score_li_bottom">成绩</div>
        </div>
        <div class="project_score_li">
          <div class="project_score_li_top">{{item.level}}</div>
          <div  class="project_score_li_bottom">等级</div>
        </div>
      </div>

      <div class="project_video">
        <div style="color:#333333;" class="dfcenter">
        <img src="@/assets/image/奖杯@3x.png" style="margin-right:3px;" width="18" alt="">
        <div>战胜
          <span style="color:#333333;font-family: DINPro-Bold;">{{item.percent||'-'}}</span>
          %的同学</div>
        </div>

          <!-- <VideoDialog :url='item.videoPath'>
         <template slot="icon">
        <div style="color:#4B88E0;" class="dfcenter">
        <img src="@/assets/image/播放.png" style="margin-right:3px;" width="18" alt="">
        <div>视频回看</div>
        </div>
         </template>
          </VideoDialog> -->
      </div>
      </div>


       <div class="noproject_score" v-else>
        <div style="height:60px;line-height: 60px;">暂无数据</div>
        <div class="project_video">
        <div style="color:#ECC843;" class="dfcenter">
        <img src="@/assets/image/奖杯@3x.png" style="margin-right:3px;" width="20" alt="">
        <div>——</div>
        </div>
        <!-- <div style="color:#bbb;" class="dfcenter">
        <img src="@/assets/image/播放无效.png" style="margin-right:3px;" width="20" alt="">
        <div>视频回看</div>
        </div> -->
      </div>
      </div>

    </div>
</div>
</van-skeleton>


<div >
      <div class="card">
      <div class="card-eachart" ref="physicalStrength"></div>
    </div>
    <div class="card">
      <div class="card-eachart" ref="physicalQuality"></div>
    </div>
    
    <!-- <div class="card">
    <img src="../../assets/image/zengzhi.jpg" alt=""  class="card-img">
    </div> -->
</div>

<div >
<div class="card tishengbox">
    <div>强项拔高</div>
    <van-divider />
    <div style="font-size:13px;margin:16px 0 6px 0;">上肢力量</div>
    <div  style="font-size:12px;color:#999;">锻炼上肢力量主要涉及肩伸展以及屈伸时、腕、学和指的关联动作，展现上肢发力有推伸力、屈拉力、拾升力和旋扭力等。</div>
    <div style="font-size:13px;margin:15px 0;color:#fff;border-radius:8px;background:#216DD9;width:80px;height:25px;line-height:25px;text-align:center;">训练方法</div>
    <div></div>
    <div style="font-size:13px;margin:16px 0 6px 0;">(1)哑铃前平举</div>
    <div  style="font-size:12px;color:#999;">站姿，两手持哑铃自然下垂于身体两侧:以肩部为轴，向前上作直警平举动作，上举至颈前与地面平行，再缓缓还原重复动作即可。锻炼角肌前末。</div>

    <div style="font-size:13px;margin:16px 0 6px 0;">(2)哑铃推举</div>
    <div  style="font-size:12px;color:#999;">坐姿或站姿，双手以哑铃反复作肩上推举，过头顶伸直臂，过程中收紧三角肌。锻炼三角肌前束。</div>
    
    <div style="font-size:13px;margin:15px 0;color:#fff;border-radius:8px;background:#216DD9;width:80px;height:25px;line-height:25px;text-align:center;">训练视频</div>
    <div style="font-size:13px;margin:16px 0 6px 0;">哑铃训练
       <van-rate
  v-model="ratevalue"
  :size="14"
  color="#ffd21e"
  void-icon="star"
  void-color="#eee"
    />
    </div>
    <video
          controls
          controlslist="nodownload  noremoteplayback"
          :disablePictureInPicture="true"
          style="width: 100%; height: 100%; object-fit: contain"
          src="./video/yaling.mp4"
          ref="video"
        ></video>
    <div style="font-size:13px;margin:16px 0 6px 0;">纵跳训练
       <van-rate
  v-model="ratevalue"
  :size="14"
  color="#ffd21e"
  void-icon="star"
  void-color="#eee"
    />
    </div>
    <video
          controls
          controlslist="nodownload  noremoteplayback"
          :disablePictureInPicture="true"
          style="width: 100%; height: 100%; object-fit: contain"
          src="./video/zongtiao.mp4"
          ref="video"
        ></video>
    <div style="margin-bottom:30px"></div>
    <div>运动处方</div>
    <van-divider />
    

    <div style="font-size:13px;margin:16px 0 6px 0;">柔韧性</div>
    <div  style="font-size:12px;color:#999;">韧带拉伸训练有助于提高身体的柔韧性，增强人体的素质，避免运动过程中的损伤。</div>
    <div style="font-size:13px;margin:15px 0;color:#fff;border-radius:8px;background:#216DD9;width:80px;height:25px;line-height:25px;text-align:center;">训练方法</div>
    <div></div>

    <div style="font-size:13px;margin:16px 0 6px 0;">(1)一字马</div>
    <div  style="font-size:12px;color:#999;">在平地上取站位，两腿逐渐向前后打开，做劈叉的动作，当两腿分开到最大限度后，让两手撑住地面，再尽力让上身做下压的动作，保持30秒。注意不要使用暴力来强制男叉。</div>

    <div style="font-size:13px;margin:16px 0 6px 0;">(2)压腿</div>
    <div  style="font-size:12px;color:#999;">找一个合适高度的横杠，横杠最不要太高。一条腿在平地上站直，另一条腿搭在横打上。两腿都要绷直，然后将身体的一侧尽量向前下方压，直到两条腿有轻微的酸痛感。</div>

    <div style="font-size:13px;margin:16px 0 6px 0;">(2)弓步下压</div>
    <div  style="font-size:12px;color:#999;">在平地上取步站位，双手放在前腿上，后腿一定要细直，然后随着上身的下压动作，去尽力压两条腿，持续30秒然后再交换前后腿，重复上述动作。</div>
    <div style="font-size:13px;margin:15px 0;color:#fff;border-radius:8px;background:#216DD9;width:80px;height:25px;line-height:25px;text-align:center;">训练视频</div>
    <div style="font-size:13px;margin:16px 0 6px 0;">俯卧撑训练
      <van-rate
  v-model="ratevalue"
  :size="14"
  color="#ffd21e"
  void-icon="star"
  void-color="#eee"
    />
</div>
    <video
          controls
          controlslist="nodownload  noremoteplayback"
          :disablePictureInPicture="true"
          style="width: 100%; height: 100%; object-fit: contain"
          src="./video/fuwocheng.mp4"
          ref="video"
        ></video>
    <div style="font-size:13px;margin:16px 0 6px 0;">仰卧起坐训练
       <van-rate
  v-model="ratevalue"
  :size="14"
  color="#ffd21e"
  void-icon="star"
  void-color="#eee"
    />
    </div>
   <video
          controls
          controlslist="nodownload  noremoteplayback"
          :disablePictureInPicture="true"
          style="width: 100%; height: 100%; object-fit: contain"
          src="./video/yangwoqizuo.mp4"
          ref="video"
        ></video>
           <div style="font-size:13px;margin:16px 0 6px 0;">半蹲起训练
       <van-rate
  v-model="ratevalue"
  :size="14"
  color="#ffd21e"
  void-icon="star"
  void-color="#eee"
    />
    </div>
   <video
          controls
          controlslist="nodownload  noremoteplayback"
          :disablePictureInPicture="true"
          style="width: 100%; height: 100%; object-fit: contain"
          src="./video/bandunqi.mp4"
          ref="video"
        ></video>
    <!-- <div v-for="(item,i) in tishengdata" class="listbox">
    <div>
        <div >{{item.name}}</div>
        <div>{{item.title}}</div>
        <div>{{item.value}}</div>
    </div>
    </div> -->
</div>
</div>



  </div>
</template>

<script>
import studentCard from "@/components/studentCard.vue";
import VideoDialog from "@/components/VideoDialog.vue";
import {
  getTermInfoList,
  querySingleFitnessEvaluationAnalysis,

  queryPhysicalIntensityAnalysis,
  queryPortraitData,
  getFinishProject
} from '@/api/fitnessReport'
import {
  getScoreListOnlyActivity,
scoreStaBySnCode,
  queryPhysicalFitnessAnalysis,
  queryPhysicalQualityAnalysis,
  getFitnessTestBySnCode
} from '@/api/fitnessReport'
import { getEduYearList} from "@/api/resultReporting.js";

import * as echarts from 'echarts'

export default {
  components: {
    studentCard,
    VideoDialog
  },
data () {
  return {
    BmiData:{
level: "肥胖",
projectCode: "HeightWeight",
projectName: "BMI",
projectUnit: "千克/米²",
score: "23.85",
value: "23.85",
height: "180.00",
weight: "90.00",
standardList: ["14.65", "21.85", "24.55"],
standards: ["14.65", "21.85", "24.55"],
    },
    yearList:[],
    showPopover:false,
    ratevalue:5,
    active:0,
    loading:true,
    data:{},
    list:[{
      projectName:'身高体重'
    },
    {
      projectName:'身高体重'
    },
    {
      projectName:'身高体重'
    }],
    finalScoreData:{},

    

    levels: [
      '低体重',
      '正常',
      '超重', 
      '肥胖', ],

    projectScoreList:[],
    fitnessTestData:[],
      tishengdata: [{
        name:'纵跳摸高',
        title:'-提升腿部肌肉和踝关节力量',
        value:'动作方法:  两脚自然开立成半蹲预备姿势，一臂或两臂向上伸直，接着两腿用力蹬伸向上跳起，用单手或双手摸高。每次练习10次左右，重复3~4组。'
      },
      {
        name:'蛙跳',
        title:'-提升大腿肌肉和关节力量',
        value:'动作方法:  两脚分开成半蹲，上体稍前倾，两臂在体后成预备姿势。两腿用力蹬伸，充分伸直髓、膝、踝三个关节，同时两臂迅速前摆，身体向前上方跳起，然后用全脚掌落地屈膝缓冲，两臂摆成预备姿势。连续进行5~7次，重复3~4组。'
      },
      {
        name:'障碍跳',
        title:'-发展腿部肌肉和踝关节爆发力。',
        value:'练习方法：地上放小海绵垫6～10块，每块距离1米左右。练习者站在垫后，两脚左右开立，脚尖平行，屈膝向下，两臂自然后摆，用脚掌力量向前上方跳过障碍，两臂配合向前上方摆动，落地时屈膝缓冲，落地后迅速做下次跳跃。重复5～6组。'
      },
{
        name:'跳台阶',
        title:'-提升腿部力量和踝关节力量。',
        value:'动作方法：两手背在身后，两脚平行开立，屈膝半蹲，用前脚掌力量做连续跳台阶动作。一次可跳20～30个台阶，重复3～4组。'
      },

{
        name:'冰棍跳',
        title:'-锻炼踝关节的灵敏度和力量值。',
        value:'练习方法：双手背在身后，两脚自然站立，膝盖伸直，前脚掌发力向上纵跳，膝盖不弯曲以练习踝关节力量，跳到脚踝微发酸为一组，重复3~4次。'
      },

{
        name:'挺身跳',
        title:'-原地屈膝开始跳，空中做直腿挺身动作，髋关节完全打开，做出背弓动作，落地时屈膝缓冲。',
        value:'单足跳前进练习：一般采用左（右）去右（左）来的方法进行练习，距离控制在25－30米左右，完成3－4组。'
      },
{
        name:'收腹跳',
        title:'-从原地直立开始起跳，空中做屈腿抱膝动作或双手在腿前击掌，落地时一定要屈膝缓冲。',
        value:''
      },
{
        name:'蹲跳起',
        title:'-提升腿部肌肉力量和踝关节力量',
        value:'动作方法：双脚左右开立，脚尖平行，屈膝向下深蹲或半蹲，两臂自然后摆。然后两腿迅速蹬伸，使髋、膝、踝三个关节充分伸直，同时两臂迅速有力向前上摆，最后用脚尖蹬离地面向上跳起，落地时用前脚掌着地屈膝缓冲，接着再跳起。每次练习15～20次，重复3～4组。'
      },
{
        name:'单脚交换跳',
        title:'-提升小腿、脚掌和踝关节力量',
        value:'动作方法：双脚左右开立，脚尖平行，屈膝向下深蹲或半蹲，两臂自然后摆。然后两腿迅速蹬伸，使髋、膝、踝三个关节充分伸直，同时两臂迅速有力向前上摆，最后用脚尖蹬离地面向上跳起，落地时用前脚掌着地屈膝缓冲，接着再跳起。每次练习15～20次，重复3～4组。'
      },

{
        name:'蹍跳步',
        title:'-发展腿部后群肌肉和踝关节的力量，训练身体的协调性',
        value:'动作方法：双脚左右开立，脚尖平行，屈膝向下深蹲或半蹲，两臂自然后摆。然后两腿迅速蹬伸，使髋、膝、踝三个关节充分伸直，同时两臂迅速有力向前上摆，最后用脚尖蹬离地面向上跳起，落地时用前脚掌着地屈膝缓冲，接着再跳起。每次练习15～20次，重复3～4组。'
      },],

  }
},
created () {
  this.data = JSON.parse(this.$route.query.data)
},
async mounted () {
  await this.getEduYearList()
  this.init()
  
},
methods: {
  toProjectLogBoard(item,i){
    this.$router.push({
      path: 'projectLogBoard',
      query: {
        projectCode: item.projectCode,
        projectName: item.projectName,
      },
    })
  },
    getSegments(item) {
    console.log(item,'item');
    
    

      const standards = [Number.NEGATIVE_INFINITY, ...item.standards, Number.POSITIVE_INFINITY];
      if (item.projectCode=='FiftyMeters'||item.projectCode=='EigthHunderMeters'||item.projectCode=='ThousandMeters') {
        // 50mi  
        return this.levels.map((level, index) => ({
        label: level,
        level: level,
        aValue:item.standards[index-1],
        bValue:item.standards[index],
        value: index === 0 ? `≥${item.standards[0]}` : 
               index === 3 ? `<${item.standards[2]}` : 
               `${item.standards[index-1]}~${item.standards[index]}`
      }));
      }
      return this.levels.map((level, index) => ({
        label: level,
        level: level,
        aValue:item.standards[index-1],
        bValue:item.standards[index],
        value: index === 0 ? `<${item.standards[0]}` : 
               index === 3 ? `≥${item.standards[2]}` : 
               `${item.standards[index-1]}~${item.standards[index]}`
      }));
    },
     // 获取可视范围（包含扩展区域）
 getVisualRange(item) {
    
      const absMin =item.standards? Math.min(...item.standards):0
      const absMax =item.standards? Math.max(...item.standards):0
      const padding = (absMax - absMin) * 0.2;
      return {
        min: absMin - padding,
        max: absMax + padding
      };
    },
// 新增segmentStyle方法
segmentStyle(seg, item) {
      const visualRange = this.getVisualRange(item);
      const start = ((seg.visualMin - visualRange.min) / (visualRange.max - visualRange.min)) * 100;
      const end = ((seg.visualMax - visualRange.min) / (visualRange.max - visualRange.min)) * 100;

      const colors = {
        '低体重': '#0eb56c',
        '正常':'#1ea5eb',
        '超重':'#f3a919',
        '肥胖':'#f16114',
      }
      
      
      return {
        width: `${end - start}%`,
        left: `${start}%`,
        'background-color': colors[seg.level]
      };
    },
      markerPosition(item) {

      let min =item.standards? Math.min(...item.standards):0
      let max =item.standards? Math.max(...item.standards):0

  
      // const pos = ((item.value - min)/(max - min)*100).toFixed(2);
      let pos = 0
      if (item.value<=min) {
        // 不及格 
        pos = (item.value/ min*100 * 0.25).toFixed(2);
      }else{
        pos = ((item.value - min)/(max - min)*75).toFixed(2);
      }

      if (item.projectCode=='FiftyMeters'||item.projectCode=='EigthHunderMeters'||item.projectCode=='ThousandMeters') {
        // 50mi  跑步倒序
        pos = ((max - item.value) / (max - min)) * 100;
      }
      if (pos>100) {
        pos = 100
      }

 

      const colors = {
        '低体重': '#0eb56c',
        '正常': '#1ea5eb',
        '超重':'#f3a919',
        '肥胖':'#f16114',
      }

      return { 
        // left: `${pos}%`,
        width: `${pos}%`,
        'background-color': colors[item.level]

       };
    },

    getLevelColor(index) {
      const colors = ['#666', '#4CAF50', '#2196F3', '#9C27B0'];
      return colors[index];
    },
   // 查询学年
 async getEduYearList(){
 await getEduYearList({
            snCode:this.data.snCode,
            schoolCode:this.data.schoolCode,
          }).then(res=>{  
            res.data.data?.forEach(el=>{
                  el.text = el.name
              if(+el.isActive==1){
                  this.data.termCode = el.code
                  this.data.termName = el.name
              }
            })
            this.yearList = res.data.data
          })
 },
      // 切换学年
      onSelectPopover(action){
        console.log(action);
         this.data.termCode = action.code
         this.data.termName = action.name
         this.init()
      },

      async queryPhysicalFitnessAnalysis () {
      const legend = []
      let indicator = []
      let series = []
      await queryPhysicalFitnessAnalysis({
        schoolCode: this.data.schoolCode,
        snCode: this.data.snCode
      }).then((data) => {
        const body = data.data.body
        console.log('body ', body)
        series = body?.series
        indicator = body?.indicator
        series.map((item) => {
          const name = item.name || ''
          item.value = item.data
          legend.push(name)
        })
      })
      console.log(legend, indicator, series);
      this.getPhysicalStrength(legend, indicator, series)
    },
   async queryPhysicalQualityAnalysis () {
      const legend = []
      let indicator = []
      let series = []
      await queryPhysicalQualityAnalysis({
         schoolCode: this.data.schoolCode,
        snCode: this.data.snCode
      }).then((data) => {
        const body = data.data.body
        series = body?.series
        indicator = body?.indicator
        series.map((item) => {
          const name = item.name || ''
          item.value = item.data
          legend.push(name)
        })
      })
      this.$nextTick(() => {
      this.getPhysicalQuality(legend, indicator, series)
      })
    },
    getPhysicalQuality (legend, indicator, series) {
      const myChart = echarts.init(this.$refs.physicalQuality)
      const option = {
        title: {
          text: '身体素质分析',
          textStyle: {
            fontSize: 16,
            fontWeight: 500
          }
        },
        legend: {
          data: legend,
          left: 'right',
          top: 0,
          orient: 'vertical'
        },
        radar: {
          indicator: indicator,
          center: ['50%', '60%'],
          radius: 100 // 雷达图缩放大小
        },
        series: [
          {
            name: 'Budget vs spending',
            type: 'radar',
            areaStyle: {},
            data: series
          }
        ]
      }

      if (option && typeof option === 'object') {
        myChart.setOption(option)
      }
      window.addEventListener('resize', myChart.resize)
    },
 getPhysicalStrength (legend, indicator, series) {
      const myChart = echarts.init(this.$refs.physicalStrength)
      const option = {
        //  color: ['#13befc','#23befc'],

        title: {
          text: '运动体能数据综合分析',
          textStyle: {
            fontSize: 16,
            fontWeight: 500
          }
        },
        legend: {
          data: legend,
          left: 'right',
          top: 0,
          orient: 'vertical'
        },
        radar: {
          indicator: indicator,
          center: ['50%', '60%'],
          radius: 100 // 雷达图缩放大小
        },
        series: [
          {
            name: 'Budget vs spending',
            type: 'radar',
            areaStyle: {},
            data: series
          }
        ]
      }

      if (option && typeof option === 'object') {
        myChart.setOption(option)
      }

      window.addEventListener('resize', myChart.resize)
    },


  init(){
    this.loading =true
    getScoreListOnlyActivity({
      snCode:this.data.snCode,
      schoolCode:this.data.schoolCode,
      termCode:this.data.termCode
    }).then(res=>{
      console.log(res);
      this.projectScoreList = res.data.data||[]
      if (res.data.data.length>0) {

//            BmiData:{
// level: "肥胖",
// projectCode: "HeightWeight",
// projectName: "BMI",
// projectUnit: "千克/米²",
// score: "23.85",
// value: "23.85",
// height: "180.00",
// weight: "90.00",
// standardList: ["14.65", "21.85", "24.55"],
// standards: ["14.65", "21.85", "24.55"],
//     },
        res.data.data.forEach(el=>{
          if (el.projectCode=='HeightWeight') {
            
            el.value = el.score
            el.standards = el.standardList
            this.BmiData = el
          }
        })
        // projectCode
        // HeightWeight
      }
      
      
      this.loading =false

    })
    
    scoreStaBySnCode({
      snCode:this.data.snCode,
      schoolCode:this.data.schoolCode,
      termCode:this.data.termCode
    }).then(res=>{
      this.finalScoreData = res.data.body||[]
    })

        this.queryPhysicalFitnessAnalysis()
        this.queryPhysicalQualityAnalysis()
    // getFitnessTestBySnCode({
    //   snCode:this.data.snCode,
    //   schoolCode:this.data.schoolCode
    // }).then(res=>{
    //   this.fitnessTestData = res.data.body||[]
    //   this.loading =false
    // })
  }
}
}
</script>
<style lang="less" scoped>
::v-deep .van-tabs--line .van-tabs__wrap{
border-radius: 8px;
   box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);

}
@font-face {
    font-family: DINPro-Bold;
   src: url(../../assets/font/DINPro-Bold.otf);
}
@font-face {
    font-family: douyuFont;
   src: url(../../assets/font/douyuFont.otf);
}
.page{
  height: 100vh;
  // overflow-y: auto;
  background-image: url("../../assets/parentImg/finessBg.png");
  background-size: 100% 180%;
  background-repeat: no-repeat;
  padding: 4vw;
}
.title_box{
  height: 440px;

  .title{
    font-size: 20px;
    font-family: douyuFont;
    color: #fff;
    margin-top: 20px;
    margin-bottom: 60px;
    // text-align: center;
  }
  .cardRoll_box{
  position: relative;
  height: 350px;
  border-radius: 15px;
  margin-top: 20px;
  // background: radial-gradient(circle, skyblue, transparent);
  box-sizing: border-box;
     .cardRoll_badgetopbox{
        position: absolute;
        top: -40px;
        right: 4vw;
        width: 100px;
        height: 150px;
        z-index: 9999;
      }
    .cardRoll_topbox{
      height: 65px;
      width: calc(100% - 8vw);
      padding: 4vw;
      background-color: rgb(255, 255, 255);
      border-radius: 15px 15px 0 0;
      box-shadow: 0px 3px 8px 0px rgba(0,0,0,0.04);
       /* 修复后的遮罩 */
  -webkit-mask: 
    radial-gradient(circle at left bottom, transparent 8px, red 0),
    radial-gradient(circle at right bottom, transparent 8px, red 0);
  -webkit-mask-size: 50.5% 100%; /* 关键：略大于50%避免缝隙 */
  -webkit-mask-position: 0, 100%;
  -webkit-mask-repeat: no-repeat;

  /* 标准属性 */
  mask: 
    radial-gradient(circle at left bottom, transparent 8px, red 0),
    radial-gradient(circle at right bottom, transparent 8px, red 0);
  mask-size: 50.5% 100%;
  mask-position: 0, 100%;
  mask-repeat: no-repeat;


overflow: visible; /* 关键：防止父级裁剪 */
  contain: none; /* 禁用contain属性 */

      .year_score{
        font-family: DINPro-Bold;
      }
   
    }
    .cardRoll_bottombox{
      position: relative;
      height: 250px;
      width: 100%;
      // padding: 4vw;
      background-color: rgb(255, 255, 255);
      border-radius: 0 0 15px 15px;
      box-shadow: 0rpx 3px 8px 0px rgba(0,0,0,0.04);
    -webkit-mask: radial-gradient(circle at 0 top, #0000 8px, red 0), radial-gradient(circle at right top, #0000 8px, red 0);
    -webkit-mask-size: 51% 100%;
    -webkit-mask-position: 0, 100%;
    -webkit-mask-repeat: no-repeat;
   overflow: visible; /* 关键：防止父级裁剪 */
  contain: none; /* 禁用contain属性 */

    .card{
      height: calc(250px - 8vw);
      width: calc(100% - 8vw);
      padding:0 4vw;
      .cardRoll_bottombox_top{
        display: flex;
        justify-content: space-between;
        font-family: DINPro-Bold;
        font-size: 24px;
  text-align: center;
      .cardRoll_bottombox_topleft{
        width: 38vw;
        height: 19vw;
        line-height: 19vw;
         background-image: url("../../assets/parentImg/身高icon.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
      }
      .cardRoll_bottombox_topright{
        width: 38vw;
        height: 19vw;

        line-height: 19vw;
         background-image: url("../../assets/parentImg/体重icon.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;

      }
      }
      .cardRoll_bottombox_bottom{
        width: 100%;
        .cardRoll_bottombox_bottomtop{
          display: flex;
        justify-content: space-between;
        margin-top: 15px;
        font-family: DINPro-Bold;

        .cardRoll_bottombox_bottomtopright{
          display: flex;

          .cardRoll_bottombox_bottomtopright_text{
            width: 40px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            border-radius: 15px;
            font-size: 12px;
            background-color: #e1eef7;
            color: #2e8bd3;
            margin-left: 8px;
          }
        }
        }




   .test-item {
        background-color: rgb(239, 250, 255);
        margin: 4vw 0;
        padding: 15px;
        border-radius: 15px;
        .test-item-header{
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
    

        }
        .test-item-bottom{
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
          font-size: 12px;
          color: rgb(153, 153, 153);
        }
      }


.progress-container {
  height: 10px;
  background: #eee;
  border-radius: 10px;
  // margin: 10px 0;
}

.main-progress {
  height: 100%;
  border-radius: 10px;
  // position: relative;
}

.current-marker {
  // position: absolute;
  width: 3px;
  height: 100%;
  // background: #ff5722;
  // top: -15%;
  // transform: translateX(-50%);
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.reference-bar {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

.segment {
  flex: 1;
  text-align: center;
  position: relative;
}
.marker{
  height: 3px;
  width: 100%;
}
.segment::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 4px;
  width: 100%;
  // background: currentColor;
}

.label {
  display: block;
  font-size: 12px;
  color: rgb(137, 170, 183);
}




      }


    }
    .card-eachart{
      height: calc(250px - 8vw);
      width:100%;
    }
    }
    .line{
      width: calc(100% - 20px);
      border-bottom: 2px dotted #dbedf7;
      margin: 0 10px;
    }



  }
}
.yearbox{
position: relative;
min-height: 440px;
// margin: 10px;
padding: 15px 20px;
border-radius: 10px;
background-image: url('../../assets/image/ticeTitle.png');
background-size: 100% 100%;
background-repeat: no-repeat, repeat;
color: #fff;
letter-spacing:1.5px;
    box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
.isStatusClass{
  position: absolute;
}
.year_title{
  font-size: 5.5vw;
  margin-bottom: 20px;
  color: #000;
}

.year_zonghe{
  color: #000;
  font-size: 5vw;
  font-weight: 500;
  margin-bottom: 10px;
}
.year_score{

}
.year_status{
  display: inline-block;
  width: 60px;
  height: 22px;
  line-height: 22px;
  background: #2972DB;
  border-radius: 10px;
  text-align: center;
  margin-left: 8px;
  font-size: 3vw;
  opacity: 0.3;

}
}
.projectBox{
    background-color: #fff;
    padding: 4vw;
    border-radius: 15px;
    font-size: 14px;
    margin-top: 15px;
  .project_titleBox{

  }
  .project_li{
    background-color: #fff;
    border-radius: 15px;
    margin: 15px 0px;
    // box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
    padding: 4vw;
    background-image: url('../../assets/parentImg/project_BG.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    
    
  }
  .project_title{
    font-size: 3.5vw;  
    font-weight: 500;
    color: #000;
  }
  .project_score{
    display: flex;
    margin: 10px 0 15px 0;
    .project_score_li{
      width: 33%;
      text-align: center;
    }
    .project_score_li_top{
    font-size: 5.5vw;  
    line-height: 5.5vw;
    margin-bottom: 5px;
    color: #2e8bd3;
    font-family: DINPro-Bold;

    }
    .project_score_li_bottom{
    color: #2e8bd3;
    font-size: 3vw;
    }
  }
  .noproject_score{
    color: #2e8bd3;
    text-align: center;
    // height: 50px;
    // line-height: 50px;
    margin: 10px 0 5px 0;
  }
  .project_video{
    font-size: 13px;
    display: flex;
    justify-content: space-between;
  }
  .dfcenter{
    display: flex;
    align-content: center;
    align-items: center;
  }

}
 .card {
    margin: 10px 0;
    padding: 4vw;
    border-radius: 15px;
    background: #ffffff;

    .switch-box {
      margin: 20px auto;
      display: flex;
      justify-content: space-between;
      border: 1px solid #23B1FB;
      align-items: center;
      width: 40%;
      height: 30px;
      font-size: 13px;
      color: #23B1FB;
      border-radius: 30px;
      // overflow: hidden;

      div {
        width: 50%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 30px;
      }

      div.active {
        background: #23B1FB;
        color: #ffffff;
      }
    }

    .card-table {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-flow: wrap;
      font-size: 14px;

      .card-td {
        margin-bottom: 20px;
        width: 50%;
        text-align: center;
      }

      .card-td-num {
        font-size: 32px;
      }

      .card-td-sub {
        color: #868686;
      }
    }

    .card-eachart {
      width: 100%;
      height: 300px;
    }
    .card-img{
      width: 100%;

    }
    .tishengbox{
      .listbox{
    display: flex;
    margin-bottom: 40px;
  }
 
  .title{
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    letter-spacing: 5px;
    text-align: center;
  }
    }

  }
</style>
